module.exports = __webpack_public_path__ + "img/intro_2x.6b1257c7.png";